import type { PortOutputFlowInterface, UnitInterface } from 'store/units/types';
import { UnitTypes } from 'unitData/types';
import type { UnitInfoTextInterface } from '.';
import {
  getBananaScreenTexts,
  getCrusherTexts,
  getCrusherVSITexts,
  getFeedAndScreenTexts,
  getFeedTexts,
  getFreeFallScreenSFTexts,
  getFreeFallScreenSSTexts,
  getGenericCrusherTexts,
  getGenericScreenTexts,
  getGrizzlyScreenTexts,
  getGrizzlyTexts,
  getGyratoryCrusherCGTexts,
  getHybridCrusherTexts,
  getImpactCrusherCITexts,
  getJawCrusherTexts,
  getKwataniScreenTexts,
  getLinearMotionScreenTexts,
  getMobileConeTexts,
  getMobileHsiTexts,
  getMobileJawAndConeTexts,
  getMobileJawTexts,
  getMobileScreenTexts,
  getMobileVsiTexts,
  getPanFeederTexts,
  getPlateFeederTexts,
  getSchenckScreenTexts,
  getScreenTexts,
  getSplitTexts,
  getStorageTexts,
  getStorageWith1OutputTexts,
  getStorageWith2OutputTexts,
  getBreakerTexts,
} from '.';
import type { UnitInfoDataInterface } from 'store/unitInfoData';
import type { SimulationResultInterface } from 'store/simulation/types';

export type GetTextsFn = (
  unit: UnitInterface,
  simulationResult: SimulationResultInterface | undefined,
  unitInfoData: UnitInfoDataInterface,
  outputFlow?: PortOutputFlowInterface,
  type?: 'TRACKED' | 'WHEELED',
) => UnitInfoTextInterface[];

export const NodeTextFnMap: Record<UnitTypes, GetTextsFn> = {
  [UnitTypes.ADD]: () => [],
  [UnitTypes.CONE_CRUSHER_CH]: getCrusherTexts,
  [UnitTypes.CONE_CRUSHER_CS]: getCrusherTexts,
  [UnitTypes.IMPACT_CRUSHER_CI]: getImpactCrusherCITexts,
  [UnitTypes.JAW_CRUSHER_CJ]: getJawCrusherTexts,
  [UnitTypes.HYBRID_CRUSHER_CR]: getHybridCrusherTexts,
  [UnitTypes.IMPACT_CRUSHER_CV]: getCrusherVSITexts,
  [UnitTypes.STORAGE]: getStorageTexts,
  [UnitTypes.STORAGE_FEEDER]: getStorageWith1OutputTexts,
  [UnitTypes.STORAGE_FEEDER_2_OUTPUTS]: getStorageWith2OutputTexts,
  [UnitTypes.FEED]: getFeedTexts,
  [UnitTypes.GYRATORY_CRUSHER_CG]: getGyratoryCrusherCGTexts,
  [UnitTypes.GENERIC_CRUSHER]: getGenericCrusherTexts,
  [UnitTypes.CONVENTIONAL_SCREEN]: getScreenTexts,
  [UnitTypes.MULTISLOPE_SCREEN]: getLinearMotionScreenTexts,
  [UnitTypes.LINEAR_MOTION_SCREEN]: getLinearMotionScreenTexts,
  [UnitTypes.BANANA_SCREEN]: getBananaScreenTexts,
  [UnitTypes.GRIZZLY_SCREEN]: getGrizzlyScreenTexts,
  [UnitTypes.SCHENCK_SCREEN]: getSchenckScreenTexts,
  [UnitTypes.KWATANI_SCREEN]: getKwataniScreenTexts,
  [UnitTypes.FREEFALL_SCREEN_SF]: getFreeFallScreenSFTexts,
  [UnitTypes.FREEFALL_SCREEN_SS]: getFreeFallScreenSSTexts,
  [UnitTypes.FEEDER_AND_SCREEN]: getFeedAndScreenTexts,
  [UnitTypes.GENERIC_SCREEN]: getGenericScreenTexts,
  [UnitTypes.PAN_FEEDER_SP]: getPanFeederTexts,
  [UnitTypes.PLATE_FEEDER_SH]: getPlateFeederTexts,
  [UnitTypes.SPLIT]: getSplitTexts,
  [UnitTypes.MOBILE_TRACKED_CONE]: getMobileConeTexts,
  [UnitTypes.MOBILE_WHEELED_CONE]: getMobileConeTexts,
  [UnitTypes.MOBILE_TRACKED_JAW]: getMobileJawTexts,
  [UnitTypes.MOBILE_WHEELED_JAW]: getMobileJawTexts,
  [UnitTypes.MOBILE_TRACKED_HSI]: getMobileHsiTexts,
  [UnitTypes.MOBILE_WHEELED_HSI]: getMobileHsiTexts,
  [UnitTypes.MOBILE_VSI]: getMobileVsiTexts,
  [UnitTypes.MOBILE_TRACKED_SCREEN]: getMobileScreenTexts,
  [UnitTypes.MOBILE_WHEELED_SCREEN]: getMobileScreenTexts,
  [UnitTypes.GRIZZLY_FEEDER_SV]: getGrizzlyTexts,
  [UnitTypes.GRIZZLY_FEEDER_SV_E]: getGrizzlyTexts,
  [UnitTypes.GRIZZLY_FEEDER_SW]: getGrizzlyTexts,
  [UnitTypes.MOBILE_JAW_AND_CONE]: getMobileJawAndConeTexts,
  [UnitTypes.BREAKER]: getBreakerTexts,

  [UnitTypes.MOBILE_JAW_COMMON]: () => [],
  [UnitTypes.MOBILE_CONE_COMMON]: () => [],
  [UnitTypes.MOBILE_SCREEN_COMMON]: () => [],
  [UnitTypes.MOBILE_HSI_COMMON]: () => [],
  [UnitTypes.PRINT_WINDOW]: () => [],
  [UnitTypes.FREE_TEXT_BOX]: () => [],
  [UnitTypes.HIGHLIGHT_TEXT_BOX]: () => [],
  [UnitTypes.GRIZZLY_FEEDER_GENERAL]: () => [],
};
